<template>
    <div>
        <template class="table-head" >
            <el-table :data="networkInfoLists" border height="460" ref="dragTable" v-loading="isLoading">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in networkInfoItems"
                    :key="index" >
                    <template slot-scope="scope">
                        {{scope.row[item.prop]}}
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        networkInfoLists: {
            type: Array
        },
        networkInfoItems: {
            type: Array
        }
    },
    data() {
        return {
            isLoading: false
        };
    }
};
</script>

<style lang="less">

</style>